// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".evaluation[data-v-1725c184]{margin-top:var(--attendee-gap-md)}", "",{"version":3,"sources":["webpack://./resources/js/apps/attendee-module/views/agenda/event-evaluations/index.vue"],"names":[],"mappings":"AACA,6BACE,iCAAF","sourcesContent":["\n.evaluation {\n  margin-top: var(--attendee-gap-md);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
